import {SkillModel} from '@/models/skill.model';
import {Observable} from 'rxjs';
import {map, retry} from 'rxjs/operators';
import {BaseApi, RequireAuthApi} from '@/api/base.api';
import {axiosInstanceAuthenticated} from '@/api/axios.config.api';

export class SkillApi extends BaseApi<SkillModel> {
  constructor() {
    super('skills', [
      RequireAuthApi.CREATE,
      RequireAuthApi.UPDATE,
      RequireAuthApi.DESTROY,
    ])
  }

  createForContestant(skills: number[]): Observable<any> {
    return axiosInstanceAuthenticated()
      .post(this.url, {skills: skills.map((x) => `${x}`)})
      .pipe(
        retry(1),
        map((response) => response.data),
      )
  }

  updateForContestant(skills: number[]): Observable<any> {
    return axiosInstanceAuthenticated()
      .put(this.url, {skills: skills.map((x) => `${x}`)})
      .pipe(
        retry(1),
        map((response) => response.data),
      )
  }
}
